import React from 'react';
import CartPageComponent from 'components/page-cart';
import CartPageProvider from 'context/cart-page';

export default function CartPage(props) {
  return (
    <CartPageProvider>
      <CartPageComponent {...props} />
    </CartPageProvider>
  );
}
